import axios from "axios";
import VueCookies from "vue-cookies";

let originHost = window.location.origin;
if (originHost.endsWith("3000")) {
  originHost = originHost.replace("3000", "8080");
}
const apiInstance = axios.create({
  baseURL: originHost + "/api",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
});

const adminInstance = axios.create({
  baseURL: originHost + "/api/admin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
});

apiInstance.interceptors.request.use(
  (config) => {
    if (VueCookies.isKey("access_token")) {
      config.headers["Authorization"] = `Bearer ${VueCookies.get(
        "access_token"
      )}`;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

apiInstance.interceptors.response.use(
  (response) => response,
  (err) => Promise.reject(err)
);

adminInstance.interceptors.request.use(
  (config) => {
    if (VueCookies.isKey("access_token")) {
      config.headers["Authorization"] = `Bearer ${VueCookies.get(
        "access_token"
      )}`;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

adminInstance.interceptors.response.use(
  (response) => response,
  (err) => Promise.reject(err)
);

export { apiInstance, adminInstance };
